<template>
  <div class="footer mainFooter">
    <div>ติดต่อเรา</div>
    <div>
      © 2559 สงวนลิขสิทธิ์ตามพระราชบัญญัติลิขสิทธิ์โดย สำนักงานการวิจัยแห่งชาติ
      (วช.)
    </div>
    <div>
      ที่อยู่ 196 ถนนพลโยธิน เขตจตุจักร กรุงเทพฯ 10900 โทรศัพท์. 02-561-2445 ต่อ
      604 และ 618 โทรสาร. 0 2579 9202
    </div>
    <div>ติดต่อผู้ดูแลเว็บไซต์ OHRS@nrct.go.th</div>
  </div>
</template>
<script>
export default {
  name: "mainFooter",
};
</script>
<style lang="scss">
.mainFooter {
  background-color: #0c4ca3;
  text-align: center;
}
</style>
